export function homeRouteI18n(): string {
  return '';
}
